import React from 'react';

import InfoSection from '../../common/card-shared-components/card-info-section';
import { Label, Text } from '../../common/card-shipment-stops/shipment-stop-section/shipment-stop-section.style';
import shipmentInformationShape from '../../../../shapes/shipment-information';
import { STOP_TYPES } from '../../../../constants';

/**
 * The terminal information section component
 * @param {object} params - Object containing props
 * @param {object} data - Data to show
 * @return {element} - The Terminal Info component
 */

// TODO: Update with actual terminal addresses
//       once BE endpoint becomes available.
const TerminalInfo = ({ data }) => {
  const { origin, destination } = data;

  const renderTerminalDetails = (stopType, stop) => {
    const titledStopType = stopType[0].toUpperCase() + stopType.slice(1);
    return (
      <div>
        <Label>{`${titledStopType} Terminal`}</Label>
        <div>
          <Text>{stop.address.address1}</Text>
          <br />
          <Text>{`${stop.address.city}, ${stop.address.state} ${stop.address.postalCode}`}</Text>
          <br />
          <Text>{stop.contactPhoneNumber}</Text>
        </div>
      </div>
    );
  };

  if (!origin || !destination) {
    return null;
  }

  return (
    <InfoSection
      header="Terminal Information"
      removePadding
    >
      <InfoSection numCols={2}>
        {renderTerminalDetails(STOP_TYPES.origin, origin)}
        {renderTerminalDetails(STOP_TYPES.destination, destination)}
      </InfoSection>
    </InfoSection>
  );
};

TerminalInfo.propTypes = {
  data: shipmentInformationShape,
};

TerminalInfo.defaultProps = {
  data: {},
};

export default TerminalInfo;
